<template>
    <div class="public-offer-cross-sell">
        <default-title class="mb-20" :size="16" :line-height="21">
            {{ specialTitle }}
        </default-title>
        <public-offer-item
            @select="selectOffer(offer)"
            @check="checkOffer(offer)"
            @update="$emit('update')"
            :key="index"
            :offer="offer"
            :showFreeTitle="showFreeTitle"
            type="crossSell"
            v-for="(offer, index) in crossSell"
        />
    </div>
</template>

<script>
import DefaultTitle from "@components/Typography/DefaultTitle"
import PublicOfferItem from "./PublicOfferItem"

export default {
    components: { PublicOfferItem, DefaultTitle },
    props: {
        crossSell: {
            type: Array,
            required: true
        },
        showFreeTitle: {
            type: Boolean,
            default: false
        }
    },
    name: "PublicOfferCrossSell",
    computed: {
        specialTitle() {
            return window.custom_translations?.special || this.t("payments.public-offer.special")
        }
    },
    methods: {
        checkOffer(offer) {
            // offer.is_checked = !offer.is_checked
            this.crossSell.forEach(el => {
                if (el.id === offer.id) el.is_checked = !offer.is_checked
            })
        },
        selectOffer(offer) {
            this.crossSell.forEach(offer => {
                offer.is_selected = false
            })
            offer.is_selected = true
        }
    }
}
</script>

<style scoped lang="sass">
.public-offer-cross-sell
    margin-bottom: 30px
    margin-top: 30px
</style>
